import axiosClient from 'utils/axiosClient';
import { Genre } from '../../models/Genre';

export interface GenreResponse {
  status: string;
  message: string;
  data: Genre[];
}

const service = {
  getGenres(name: string, deleteFlg: number): Promise<GenreResponse> {
    const url = `genres?name=${name}&delete_flg=${deleteFlg}`;
    return axiosClient.get(url);
  },
  deleteGenres(ids: string): Promise<GenreResponse> {
    const body = {
      ids: ids,
    };
    const url = `genre/delete-multi`;
    return axiosClient.post(url, body);
  },
  restoreDelete(id: number): Promise<GenreResponse> {
    const body = {
      id: id,
    };
    const url = `genre/restore-delete`;
    return axiosClient.post(url, body);
  },
};

export default service;
